/*
 * File: CollapseCard.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/02/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles collapsing the top of the chart
 */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Collapse } from "@material-ui/core";
import PatientCard from "./PatientCard";
import CollapseActions from "./CollapseActions";

const styles = theme => ({
  topofchart: {
    minHeight: theme.spacing(11)
  },

  cardContainer: {
    display: "flex",
    flexDirection: "row",
    margin: `${theme.spacing(1.5)}px ${theme.spacing(2)}px`
  }
});

const CollapseCard = ({
  classes,
  patient,
  expanded,
  onToggle,
  providerModel
}) => (
  <div>
    <div className={classes.topofchart}>
      <Collapse in={expanded} collapsedHeight={"90px"} timeout="auto">
        <div className={classes.cardContainer}>
          <PatientCard patient={patient} providerModel={providerModel} />
          <CollapseActions expanded={expanded} onToggle={onToggle} />
        </div>
      </Collapse>
    </div>
  </div>
);

CollapseCard.propTypes = {
  classes: PropTypes.object.isRequired,
  patient: PropTypes.object.isRequired,
  providerModel: PropTypes.object.isRequired,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func
};

export default withStyles(styles)(CollapseCard);
